/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import React from "react";
import VirtualizedGrid from "../custom/VirtualizedGrid";
import { AiOutlineClose } from "react-icons/ai";
import { MetadaDataCardData } from "../maps/MapVizClusters";

interface ImagesCardProps {
	data: GeoJSON.Feature<GeoJSON.Geometry>[];
	setShowImgGrid: (e: boolean) => void;
	setModalOpen: (e: boolean) => void;
	setModalData: (data: MetadaDataCardData) => void;
}

const ImagesCard = ({
	data,
	setShowImgGrid,
	setModalOpen,
	setModalData,
}: ImagesCardProps) => {
	return (
		<div className="absolute bottom-0 right-0 h-[300px] md:h-[100vh] w-[400px] bg-black text-white overflow-hidden z-20">
			<div
				className="absolute top-0 right-0 text-white bg-black p-1 cursor-pointer z-50"
				onClick={() => setShowImgGrid(false)}
			>
				<AiOutlineClose />
			</div>

			<div className="py-2 px-4 h-[60px]">
				<h1 className="font-bold">Image Sample</h1>
				<p className="text-xs">
					Explore a set of images after selecting a cluster on the map.
				</p>
			</div>

			<VirtualizedGrid
				data={data}
				setModalOpen={setModalOpen}
				setModalData={setModalData}
			/>
		</div>
	);
};

export default ImagesCard;
